/**
 * Home root tiles Swiper density — single source for JS options and SSR
 * pre-init CSS (must stay aligned or hydration CLS returns).
 */
export type HomeRootTilesBreakpoint = {
  /** 0 = base (no min-width media query) */
  minWidth: number
  slidesPerView: number
  spaceBetween: number
}

export const HOME_ROOT_TILES_LAYOUT: readonly HomeRootTilesBreakpoint[] = [
  { minWidth: 0, slidesPerView: 2, spaceBetween: 8 },
  { minWidth: 640, slidesPerView: 3, spaceBetween: 10 },
  { minWidth: 768, slidesPerView: 4, spaceBetween: 10 },
  { minWidth: 1024, slidesPerView: 5, spaceBetween: 10 },
  { minWidth: 1280, slidesPerView: 6, spaceBetween: 10 },
]

export function homeRootTilesSwiperDensity() {
  const [base, ...rest] = HOME_ROOT_TILES_LAYOUT
  return {
    slidesPerView: base.slidesPerView,
    spaceBetween: base.spaceBetween,
    breakpoints: Object.fromEntries(
      rest.map(bp => [
        bp.minWidth,
        { slidesPerView: bp.slidesPerView, spaceBetween: bp.spaceBetween },
      ]),
    ),
  }
}

/** Largest slidesPerView — used for eager image count. */
export const HOME_ROOT_TILES_EAGER_COUNT = Math.max(
  ...HOME_ROOT_TILES_LAYOUT.map(bp => bp.slidesPerView),
)

/**
 * Pre-init slide widths matching Swiper’s formula:
 * `(100% - (n-1)*gap) / n`, margin-right = gap (0 on :last-child).
 */
export function homeRootTilesPreInitCss(
  sliderClass = 'home-root-tiles__slider',
  slideClass = 'home-root-tiles__slide',
): string {
  return HOME_ROOT_TILES_LAYOUT.map(({ minWidth, slidesPerView, spaceBetween }) => {
    const gaps = (slidesPerView - 1) * spaceBetween
    const width = `calc((100% - ${gaps}px) / ${slidesPerView})`
    const body = `
.swiper.${sliderClass}:not(.swiper-initialized) .${slideClass} {
  width: ${width};
  margin-right: ${spaceBetween}px;
}
.swiper.${sliderClass}:not(.swiper-initialized) .${slideClass}:last-child {
  margin-right: 0;
}`
    return minWidth === 0
      ? body
      : `@media (min-width: ${minWidth}px) {${body}}`
  }).join('\n')
}
